module.exports = __webpack_public_path__ + "static/5-f604e4a617225fc471c3c273ce1b1dfe.png";